import { Html5QrcodeScanner } from "html5-qrcode";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleLoginAction } from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import HeaderReq from "../../../scripts/functions/headerReq";
const qrcodeRegionId = "html5qr-code-full-region";

const createConfig = (props) => {
  let config = {};
  if (props.fps) {
    config.fps = props.fps;
  }
  if (props.qrbox) {
    config.qrbox = props.qrbox;
  }
  if (props.aspectRatio) {
    config.aspectRatio = props.aspectRatio;
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip;
  }
  return config;
};
var isLoading = false;
const QrCode = ({ handleBack, active }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onNewScanResult = (decodedText, decodedResult) => {
    if (!isLoading) {
      isLoading = true;

      axiosInstance
        .post(
          API.auth.loginQr,
          {
            chQRTypeCode: "LoginQR",
            chEncryptedQRCode: decodedText,
          },
          HeaderReq()
        )
        .then((res) => {
          if (res?.data?.data?.chToken) {
            toast.success("با موفقیت اسکن شد در حال انتقال به صفحه اصلی");
            navigate("/");
            dispatch(
              handleLoginAction({
                userName: res?.data?.data?.chUserTitle,
                token: res?.data?.data?.chToken,
              })
            );
          } else {
            toast.error(res?.data?.message);
            isLoading = false;
          }
        })
        .catch((err) => {
          isLoading = false;
          toast.error("خطایی رخ داده است مجدد تلاش کنید");
        });
    }
  };
  const props = {
    fps: 10,
    qrbox: 250,
    disableFlip: false,
    qrCodeSuccessCallback: onNewScanResult,
  };
  useEffect(() => {
    if (!active) return;
    const config = createConfig(props);
    const verbose = props.verbose === true;
    if (!props.qrCodeSuccessCallback) {
      throw "qrCodeSuccessCallback is required callback.";
    }
    const html5QrcodeScanner = new Html5QrcodeScanner(
      qrcodeRegionId,
      config,
      verbose
    );
    html5QrcodeScanner.render(
      props.qrCodeSuccessCallback,
      props.qrCodeErrorCallback
    );

    return () => {
      html5QrcodeScanner.clear().catch((error) => {
        console.error("Failed to clear html5QrcodeScanner. ", error);
      });
    };
  }, []);
  useEffect(() => {
    if (!active) return;
    const button1 = document.getElementById(
      "html5-qrcode-button-camera-permission"
    );
    if (button1) button1.click();
  }, []);
  useEffect(() => {
    if (!active) return;
    const interval = setInterval(() => {
      const button1 = document.getElementById(
        "html5-qrcode-button-camera-permission"
      );
      const button2 = document.getElementById(
        "html5-qrcode-button-camera-stop"
      );
      const button3 = document.getElementById(
        "html5-qrcode-button-camera-start"
      );
      const button4 = document.getElementById(
        "html5-qrcode-anchor-scan-type-change"
      );
      if (button1) {
        button1.innerText = "برای ثبت پرمیژن استفاده از دوربین گوشی کلیک کنید";
      }
      if (button2) button2.innerText = "توقف اسکن";

      if (button3) button3.innerText = "شروع اسکن";
      if (button4) button4.style = "display:none";
    }, 500); // 1000 milliseconds = 1 second

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);
  if (!active) return <></>;
  return (
    <div className="my-auto max-w-xl mx-auto  mt-2 px-3">
      <div id={qrcodeRegionId} />
    </div>
  );
};

export default QrCode;
